'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dBase64$002dString$0024 from "./presto.types$-Base64-String$.js";
import * as $j_presto$002etypes$0024$002dSome$002dHash$0024 from "./presto.types$-Some-Hash$.js";
var $p;
/** @constructor */
function $c_Lpresto_AgentView$$anon$42() {
  this.azu = null;
  this.azs = null;
  this.azt = false;
  this.azq = null;
  this.azr = false;
  this.azv = false;
  this.azw = false;
  this.azu = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
}
export { $c_Lpresto_AgentView$$anon$42 as $c_Lpresto_AgentView$$anon$42 };
$p = $c_Lpresto_AgentView$$anon$42.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_AgentView$$anon$42;
/** @constructor */
function $h_Lpresto_AgentView$$anon$42() {
}
export { $h_Lpresto_AgentView$$anon$42 as $h_Lpresto_AgentView$$anon$42 };
$h_Lpresto_AgentView$$anon$42.prototype = $p;
$p.a1 = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a);
});
$p.ac = (function() {
  return this.azu;
});
$p.t = (function() {
  if ((!this.azt)) {
    this.azs = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("hash", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("signature", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.azt = true;
  }
  return this.azs;
});
$p.ad = (function() {
  if ((!this.azr)) {
    this.azq = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dSome$002dHash$0024.$m_Lpresto_types$SomeHash$().a2s(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dBase64$002dString$0024.$m_Lpresto_types$Base64String$().nP(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.azr = true;
  }
  return this.azq;
});
$p.v = (function() {
  if ((!this.azw)) {
    this.azv = false;
    this.azw = true;
  }
  return this.azv;
});
$p.ab = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredEncoder__encodeProduct__O__Lio_circe_JsonObject(this, a);
});
var $d_Lpresto_AgentView$$anon$42 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_AgentView$$anon$42, "presto.AgentView$$anon$42", ({
  E5: 1,
  a: 1,
  j: 1,
  n: 1,
  o: 1,
  p: 1,
  d: 1
}));
export { $d_Lpresto_AgentView$$anon$42 as $d_Lpresto_AgentView$$anon$42 };
//# sourceMappingURL=presto.-Agent-View$$anon$42.js.map
